// icon:play | Entypo http://entypo.com/ | Daniel Bruce
import * as React from "react";

function IconPlay(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 500 1000"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M486 474c9.333 6.667 14 15.333 14 26 0 9.333-4.667 17.333-14 24L58 790c-16 10.667-29.667 12.667-41 6-11.333-6.667-17-20-17-40V242c0-20 5.667-33.333 17-40 11.333-6.667 25-4.667 41 6l428 266" />
    </svg>
  );
}

export default IconPlay;
